import type React from 'react';

import { Typography } from '@mui/material';
import { OrdCreateInDialogButton, OrdEditInDialogButton, useIsReadonly } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { UserNumberFields } from '@ragu-components/ord-types';
import { RecordContextProvider, ReferenceManyField, useTranslate, WrapperField } from 'react-admin';

import { UserNumberList } from '../userNumbers/UserNumberList';
import { UserNumbersForm } from '../userNumbers/UserNumbersForm';

import type { UserRead } from '@ragu-components/ord-types';

export const UserNumbersTab = ({ user }: { user: UserRead }): React.ReactElement => {
  const readonly = useIsReadonly();
  const translate = useTranslate();

  const createButton = (
    <OrdCreateInDialogButton inline fullWidth>
      <UserNumbersForm embedded defaultValues={{ owner: user.id }} />
    </OrdCreateInDialogButton>
  );

  const editButton = (
    <OrdEditInDialogButton mutationMode='pessimistic' fullWidth>
      <UserNumbersForm embedded />
    </OrdEditInDialogButton>
  );

  const emptyMessage = (
    <Typography color='text.secondary' sx={{ p: 2 }}>
      {translate('ra.navigation.no_results')}
    </Typography>
  );

  return (
    <RecordContextProvider value={user}>
      <ReferenceManyField target={UserNumberFields['owner.id']} reference={Resources.user_numbers}>
        <UserNumberList
          embeddedChildren={<WrapperField label={createButton}>{editButton}</WrapperField>}
          layout='embedded'
          empty={readonly ? emptyMessage : createButton}
        />
      </ReferenceManyField>
    </RecordContextProvider>
  );
};
